const playerData = require('playerData');
const constants = require('constants');
const localConfig = require('localConfig');
const HttpUtil = require("HttpUtil");
const configuration = require('configuration');
const gameLogic = require('gameLogic');

const registerGameObj = cc.Class({
    extends: cc.Component,

    properties: {

        registerPanel: {
            type: cc.Node,
            default: null,
        },
    },


    start() {
        // this.registerPanel.getChildByName('content').getChildByName('accountPanel').getChildByName('playerName').active = false;

        let loginBtn = this.registerPanel.getChildByName('content').getChildByName('LoginBtn');
        let registerBtn = this.registerPanel.getChildByName('content').getChildByName('RegisterBtn');
        // let randomNameBtn = this.registerPanel.getChildByName('content').getChildByName('accountPanel').getChildByName('changeNameBtn');

        let loginPanel = this.registerPanel.getChildByName('content')
        let registerPanel = this.registerPanel.getChildByName('registerContent')
        let registerBtn2 = this.registerPanel.getChildByName('registerContent').getChildByName('RegisterBtn');
        let btnTerm = this.registerPanel.getChildByName('content').getChildByName('btnTerm');
        let termImg = this.registerPanel.getChildByName('content').getChildByName('btnTerm').getChildByName('termImg');
        let serviceLb = this.registerPanel.getChildByName('content').getChildByName('serviceLb');

        let terms = this.registerPanel.getChildByName('terms');
        let closeBtn = this.registerPanel.getChildByName('terms').getChildByName('closeBtn');

        let scrollView = this.registerPanel.getChildByName('terms').getChildByName('scrollView');
        let itemLb = scrollView.getChildByName('content').getChildByName("item");

        btnTerm.on("click", function () {
            if (this.select_term != null && this.select_term == true) {
                this.select_term = null;
                termImg.active = false;
            } else {
                this.select_term = true;
                termImg.active = true;
            }
        }.bind(this));

        serviceLb.on("click", function () {
            terms.active = true;
            // var a = '                               Terms and Conditions\nWelcome to Battle of Sword ("the Game"). These Terms and Conditions ("Terms") govern your use of the Game, provided by HONG KONG BA DING TRADING CO., LIMITED ("we," "us," or "our"). By accessing or using the Game, you agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use the Game.\nSharkgamers provides the Services (defined below) subject to these Terms of Service, to the exclusion of any other terms and conditions stipulated or referred to by you (the Customer). You acknowledge that you have been informed of the contents of these Terms of Service and agree to be bound by them. Any new features, upgrades, changes or new packages added to the current Services shall also be subject to these Terms of Service. Sharkgamers reserves the right to change, modify, delete, update or suspend these Terms of Service (or any part thereof) at its sole discretion without prior notice to you. Therefore, you understand and acknowledge that it is your obligation to review these Terms of Service regularly.\nIf you breach any of these Terms of Service, Sharkgamers shall have the exclusive and absolute right to terminate, suspend or withdraw the Services to you. If you breach these Terms of Service, Sharkgamers reserves the right to seek any remedy or relief to the extent permitted by law, including, but not limited to, injunction, damages and/or specific performance.\nAcceptance of Terms\nBy accessing or using our Services, you acknowledge that you can form a binding contract with Sharkgamers.com and that you accept these Terms and agree to abide by them. Your access to and use of our Services is also subject to any regulations governing the gaming industry in your jurisdiction.\nEligibility\nYou must be at least 18 years old to access and use the Game. By accessing or using the Game, you represent and warrant that you meet this age requirement.\nAccount Registration\nTo access certain features of the Game, you may need to create an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete. You are responsible for safeguarding your account information and for all activities that occur under your account.\nAccount Security\n';
            // a += 'To access or use our Services, you must create an account with us. When creating this account, you must provide accurate information.\nPlease keep your account password confidential and do not disclose it to others.\nYou agree that you are solely responsible for all correct activities that occur under your account, whether or not the activity actually originates from you. If you know or suspect that any third party knows your password or has accessed your account, you can reset your password by receiving a password recovery link through your registered email address.\nWe reserve the right to disable your user account at any time, including if you fail to comply with any provision of these Terms, or if the activity that occurs on your account, in our sole discretion, may or may damage or impair the Services or otherwise infringe the rights of others or violate any applicable laws or regulations.\nIf you no longer wish to use our Services again and wish to delete your account, please contact our Customer Service team via email. We will guide you through the process. Once you choose to delete your account, you will not be able to reactivate your account or retrieve any content or information in your account.\nUser Conduct\n'
            // a += 'You agree to use the Game in accordance with the following guidelines:\n- Do not use the Game for any illegal or unauthorized purpose.\n- Do not engage in any activity that could damage, disable, overburden, or impair the functioning of the Game.\n- Do not interfere with or disrupt the integrity or performance of the Game or the data contained therein.\n- Do not attempt to gain unauthorized access to the Game or its related systems or networks.\n- Do not use the Game to transmit any viruses, worms, or malicious code.\n'
            // a += 'Intellectual Property\nAll content, trademarks, service marks, trade names, logos, and intellectual property rights in the Game are the property of HONG KONG BA DING TRADING CO., LIMITED or its licensors. You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Game without our express written permission.\nRefund Terms\nWe offer a full refund guarantee for all purchases made on our website, provided the item you purchased has not been used.\nThe maximum period to request a refund is 7 calendar days after purchase. After 7 days, you will no longer be eligible and will not be able to get a refund.\nIf you have any other questions, disputes or would like to request a refund, please feel free to contact us.\nPrivacy Policy\n'
            // a += 'Sharkgamers.com records the behavior of users as they browse the website. This tracking is completely anonymous and is only used to analyze the user journey. For example, data is collected on which pages users visit and in which areas of the website they spend the most time.\nIn addition, Sharkgamers collects IP addresses, operating system details, and web browser information. In addition, we also track how users find us so that we understand what drives traffic to our website. All of this is only used to optimize our website and improve the overall user experience of Sharkgamers.\nTermination\nWe reserve the right to suspend or terminate your access to the Game at any time, without notice, for any reason, including if you violate these Terms. Upon termination, all licenses and rights granted to you in these Terms will immediately cease.\n'
            // a += 'To the maximum extent permitted by law, HONG KONG BA DING TRADING CO., LIMITED shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (a) your use or inability to use the Game; (b) any unauthorized access to or use of our servers and/or any personal information stored therein; (c) any bugs, viruses, trojan horses, or the like that may be transmitted to or through the Game by any third party; (d) any errors or omissions in any content or for any loss or damage incurred as a result of your use of any content posted, emailed, transmitted, or otherwise made available through the Game; and/or (e) the defamatory, offensive, or illegal conduct of any third party.\nGoverning Law\nThese Terms and any disputes related to them or the Game will be governed by and construed in accordance with the laws of the Hong Kong Special Administrative Region.\nChanges to Terms\nWe may modify these Terms at any time. If we do so, we will provide notice by posting the new Terms on our website or through the Game. Your continued use of the Game following such notice constitutes your acceptance of the updated Terms.\nContact Information\n'
            // a += 'If you have any questions about these Terms, please contact us:\nEmail:service@sharkgamers.com\nHONG KONG BA DING TRADING CO., LIMITED\nUNIT 135 1/F 143 WAI YIP STREET KWUN TONG KL'
            // itemLb.getComponent(cc.Label).string = a;
        }.bind(this));

        closeBtn.on("click", function () {
            terms.active = false;
        }.bind(this));

        loginBtn.on("click", function () {
            this.onBtnLogin();
        }.bind(this));

        registerBtn.on("click", function () {
            loginPanel.active = false;
            registerPanel.active = true;
        }.bind(this));

        registerBtn2.on("click", function () {
            this.onBtnRegister();
        }.bind(this));

        // randomNameBtn.on("click", function () {
        //     this.onBtnChangeNameClick();
        // }.bind(this));

        let account = configuration.getGlobalData(constants.LOCAL_CACHE.ACCOUNT);
        if (!account) {
            // this.onBtnChangeNameClick();
        } else {
            var playerName = this.registerPanel.getChildByName('content').getChildByName('accountPanel').getChildByName('playerName');
            playerName.getComponent(cc.EditBox).string = account;
        }

    },

    showTips(tips) {
        var tipTxt = this.registerPanel.getChildByName('tipTxt');
        tipTxt.stopAllActions();
        tipTxt.getComponent(cc.Label).string = tips;
        tipTxt.active = true;
        tipTxt.position = cc.v2(0, 0);
        const moveAction = cc.sequence(cc.moveBy(0.3, 0, 40).easing(cc.easeIn(0.6)), cc.delayTime(0.7), cc.callFunc(() => {
            tipTxt.active = false;
            tipTxt.stopAllActions();
        }));

        tipTxt.runAction(moveAction);
    },

    onBtnChangeNameClick() {
        cc.gameSpace.audioManager.playSound(constants.AUDIO_SOUND.CLICK);
        this.nickNameArr = localConfig.getTableArr('nickName');
        var randomIndex = Math.floor(Math.random() * this.nickNameArr.length);
        var playerName = this.registerPanel.getChildByName('content').getChildByName('accountPanel').getChildByName('playerName');
        playerName.getComponent(cc.EditBox).string = this.nickNameArr[randomIndex].nickName;

    },
    onBtnRegister() {
        var playerName = this.registerPanel.getChildByName('registerContent').getChildByName('accountPanel').getChildByName('playerName');
        var passwordName1 = this.registerPanel.getChildByName('registerContent').getChildByName('passwordPanel1').getChildByName('passwordName');
        var passwordName2 = this.registerPanel.getChildByName('registerContent').getChildByName('passwordPanel2').getChildByName('passwordName');
        var playerNameEd = playerName.getComponent(cc.EditBox).string;
        var passwordNameEd1 = passwordName1.getComponent(cc.EditBox).string;
        var passwordNameEd2 = passwordName2.getComponent(cc.EditBox).string;
        if (playerNameEd == "") {
            this.showTips("user name empty");
            return;
        }
        if (passwordNameEd1 == "") {
            this.showTips("password empty");
            return;
        }

        if (passwordNameEd2 == "") {
            this.showTips("password empty");
            return;
        }

        if (passwordNameEd1 != passwordNameEd2) {
            this.showTips("password not same");
            return;
        }

        var self = this;
        this.showLoading();
        HttpUtil.request("user/register", {}, "POST", function (err, data) {
                self.hideLoading();
                if (err) {
                    cc.log(err);
                    return;
                }

                if (data.status == 200) {
                    self.uid = playerNameEd;
                    self.userLogin(data.result);
                } else {
                    self.showTips(data.message);
                }
            }, 30000,
            JSON.stringify({
                password: passwordNameEd1,
                username: playerNameEd
            })
        );
    },

    onBtnLogin() {
        if (!this.select_term || this.select_term == null || this.select_term == undefined) {
            this.showTips("please check terms");
            return;
        }

        var playerName = this.registerPanel.getChildByName('content').getChildByName('accountPanel').getChildByName('playerName');
        var passwordName = this.registerPanel.getChildByName('content').getChildByName('passwordPanel').getChildByName('passwordName');
        var playerNameEd = playerName.getComponent(cc.EditBox).string;
        var passwordNameEd = passwordName.getComponent(cc.EditBox).string;
        if (playerNameEd == "") {
            this.showTips("user name empty");
            return;
        }
        if (passwordNameEd == "") {
            this.showTips("password empty");
            return;
        }

        var self = this;
        this.showLoading();
        HttpUtil.request("user/login", {}, "POST", function (err, data) {
                self.hideLoading();
                if (err) {
                    console.log(err);
                    return;
                }
                if (data.status == 200) {
                    self.uid = playerNameEd;
                    self.userLogin(data.result);
                } else {
                    self.showTips(data.message);
                }
            }, 30000,
            JSON.stringify({
                password: passwordNameEd,
                username: playerNameEd
            })
        );
    },

    userLogin(result) {
        playerData.syncServerTime(Date.now());

        cc.gameSpace.token = result.token;
        cc.gameSpace.userId = result.user.id;
        playerData.userId = this.uid;
        configuration.setGlobalData(constants.LOCAL_CACHE.ACCOUNT, result.user.name);
        configuration.setUserId(this.uid);
        playerData.loadFromCache();
        playerData.savePlayerName(result.user.name);
        playerData.gameData.gold = result.user.gold;
        if (!playerData.isNewBee) {
            playerData.dailyLoginCanGetCount = 0;
            this.todayIndex = new Date().getDay();

            if (!playerData.gameData.dailyWelfareGet) {
                playerData.todayFirstLogin = true;
            } else {
                gameLogic.offLineReward();
            }
        }

        if (playerData.isNewBee || playerData.continuousLogin) {
            gameLogic.updateTaskData(constants.taskId.continuousLogin);
        } else {
            gameLogic.updateTaskData(constants.taskId.continuousLogin, 1);
        }

        cc.director.preloadScene('mainScene', function (err) {
            if (!err) {
                cc.director.loadScene('mainScene', function () {

                });
            }
        });

    },

    showLoading() {
        let loadNode = this.registerPanel.getChildByName('loadNode')
        loadNode.active = true;
    },

    hideLoading() {
        let loadNode = this.registerPanel.getChildByName('loadNode')
        loadNode.active = false;
    }


});

kf.addModule('component.registerGame', () => registerGameObj);